var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1019 5.95469C9.80328 6.24178 9.3285 6.23247 9.04141 5.93389L5.33203 1.99614L1.62265 5.93389C1.33556 6.23247 0.860778 6.24178 0.562199 5.95469C0.26362 5.66759 0.254311 5.19281 0.541406 4.89423L4.79141 0.39423C4.93281 0.247171 5.12802 0.164062 5.33203 0.164062C5.53604 0.164061 5.73125 0.247171 5.87265 0.39423L10.1227 4.89423C10.4098 5.19281 10.4004 5.66759 10.1019 5.95469Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorStroke);
export default __webpack_public_path__ + "static/media/VectorStroke.9fc01fee42624162fdd79bd6c487b1a9.svg";
export { ForwardRef as ReactComponent };